import { Link, useNavigate, useParams } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import CardSVG from "../../assets/cart-plus-svgrepo-com.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { message, Modal } from "antd";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { language } from "../../language/Language";
import Loader2 from "../../Components/Loader2";
import { useGetBrandByIdQuery } from "../../RTK/Slices/Slices/apiSliceMeat";
import {
  getFavorites,
  addToFavorites,
  isFavorite,
  addToCart,
  calculateDiscountedPrice,
} from "../../utils/localStorage";
import ProductsFilter from "../Products/ProductsFilter";
import ProductCard from "../../Components/ProductCard";

function ProductsBrand() {
  const { id } = useParams();
  const {
    data: BrandData,
    isLoading,
  } = useGetBrandByIdQuery(id);

  const navigate = useNavigate();

  // استخرام اسم البراند من البيانات
  const brandName = BrandData?.data[0]?.name || "Brand";
  // استخراج بيانات المنتجات والصفحات من الرد
  const AllProducts = useMemo(() => BrandData?.data[0]?.products ?? [], [BrandData]);

  console.log("ProductsBrand AllProducts :", AllProducts);

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [, setFilters] = useState({
    searchQuery: "",
    priceRange: [0, 6000],
    selectedCategories: [],
    sortOption: "default",
  });

  // حالة المفضلة والسلة من localStorage
  const [, setLocalFavorites] = useState([]);
  const [, setLocalCart] = useState([]);

  // حالة ظهور المودال
  const [isModalVisible, setIsModalVisible] = useState(false);

  // تحديث المفضلة والسلة من localStorage
  const updateLocalStorage = () => {
    setLocalFavorites(getFavorites());
    setLocalCart(JSON.parse(localStorage.getItem("cart") || "[]"));
  };

  useEffect(() => {
    updateLocalStorage();

    // إضافة مستمع للتغييرات في localStorage
    const handleStorageChange = () => {
      updateLocalStorage();
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (AllProducts.length > 0) {
      // فلترة المنتجات لاستبعاد التي لديها stock = 0
      const availableProducts = AllProducts.filter(
        (product) => parseFloat(product.stock) > 0
      );

      setFilteredProducts(availableProducts);
      const highestPrice = Math.max(
        ...availableProducts.map((p) => parseFloat(p.price))
      );
      setFilters((prev) => ({
        ...prev,
        priceRange: [0, highestPrice],
      }));
    }
  }, [AllProducts]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);

    // البدء بالمنتجات المتاحة فقط (stock > 0)
    let result = AllProducts.filter((product) => parseFloat(product.stock) > 0);

    if (newFilters.searchQuery) {
      const query = newFilters.searchQuery.toLowerCase();
      result = result.filter((product) =>
        product.name.toLowerCase().includes(query)
      );
    }

    result = result.filter(
      (product) =>
        parseFloat(product.price) >= newFilters.priceRange[0] &&
        parseFloat(product.price) <= newFilters.priceRange[1]
    );

    if (newFilters.selectedCategories.length > 0) {
      result = result.filter((product) =>
        newFilters.selectedCategories.includes(product.cat_id)
      );
    }

    if (newFilters.sortOption !== "default") {
      result = sortProducts(result, newFilters.sortOption);
    }

    setFilteredProducts(result);
  };

  const sortProducts = (products, sortOption) => {
    const sortedProducts = [...products];

    switch (sortOption) {
      case "price_asc":
        return sortedProducts.sort((a, b) => a.price - b.price);
      case "price_desc":
        return sortedProducts.sort((a, b) => b.price - a.price);
      case "discount_asc":
        return sortedProducts.sort(
          (a, b) => a.default_sales_discount - b.default_sales_discount
        );
      case "discount_desc":
        return sortedProducts.sort(
          (a, b) => b.default_sales_discount - a.default_sales_discount
        );
      case "name_asc":
        return sortedProducts.sort((a, b) => a.name.localeCompare(b.name));
      case "name_desc":
        return sortedProducts.sort((a, b) => b.name.localeCompare(a.name));
      default:
        return sortedProducts;
    }
  };

  // استبدال API calls بـ localStorage functions
  const [quantity] = useState(1);

  // دالة التأكد من التسجيل
  const isUserLoggedIn = () => {
    return !!localStorage.getItem("user");
  };

  const showLoginModal = () => {
    setIsModalVisible(true);
  };

  const handleAddToFavourite = async (product, event) => {
    event.stopPropagation();

    if (!isUserLoggedIn()) {
      showLoginModal();
      return;
    }

    try {
      // تحويل بيانات المنتج للتوافق مع localStorage
      const productData = {
        product_id: product.product_id,
        name: product.name,
        price: product.price,
        default_sales_discount: product.default_sales_discount || 0,
        image_url: product.image_url,
        stock: product.stock,
      };

      const wasAdded = addToFavorites(productData);

      if (wasAdded) {
        message.success("تمت إضافة المنتج إلى المفضلة بنجاح!");
      } else {
        message.success("تمت إزالة المنتج من المفضلة!");
      }

      // تحديث الحالة المحلية
      updateLocalStorage();
    } catch (error) {
      console.error(error);
      message.error("فشل في إدارة المفضلة. حاول مجدداً.");
    }
  };

  const handleAddToCart = async (product, productQuantity, event) => {
    event.stopPropagation();

    try {
      // تحويل بيانات المنتج للتوافق مع localStorage
      const productData = {
        product_id: product.product_id,
        variation_id: product.variation_id,
        name: product.name,
        price: product.price,
        default_sales_discount: product.default_sales_discount || 0,
        image_url: product.image_url,
        stock: product.stock,
      };

      const success = addToCart(productData, productQuantity);

      if (success) {
        message.success("تمت إضافة المنتج إلى السلة بنجاح!");
        // تحديث الحالة المحلية
        updateLocalStorage();
      } else {
        message.error("فشل إضافة المنتج إلى السلة. تحقق من المخزون المتاح.");
      }
    } catch (error) {
      console.error(error);
      message.error("فشل إضافة المنتج إلى السلة. حاول مجدداً.");
    }
  };

  return (
    <div className="bg-gray-100 py-28">
      <div className="container">
        {/* <Heading title={language === "ar" ? "منتجاتنا" : "P R O D U C T S"} /> */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-red-600 inline-block relative">
            {brandName}
            <span className="block w-2/3 mx-auto h-1 bg-red-500 mt-2 rounded-full"></span>
          </h1>
        </div>
        <div className="grid grid-cols-1 gap-6">
          <div className="">
            <ProductsFilter
              products={AllProducts}
              onFilterChange={handleFilterChange}
            />
          </div>

          <div className="">
            {isLoading ? (
              <div className="flex justify-center items-center py-20">
                <Loader2 />
              </div>
            ) : filteredProducts.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {filteredProducts.map((product) => (
                  <ProductCard
                    key={product.product_id}
                    product={product}
                    onAddToCart={handleAddToCart}
                    onAddToFavourite={handleAddToFavourite}
                  />
                ))}
              </div>
            ) : (
              <div className="bg-white p-8 rounded-lg text-center">
                <h3 className="text-xl font-medium text-gray-700">
                  {language === "ar"
                    ? "لا توجد منتجات متطابقة"
                    : "No matching products found"}
                </h3>
                <p className="text-gray-500 mt-2">
                  {language === "ar"
                    ? "حاول تغيير معايير البحث الخاصة بك"
                    : "Try changing your filter criteria"}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* المودال الخاص بتسجيل الدخول */}
        <Modal
          title={language === "ar" ? "تنبيه" : "Warning"}
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={[
            <div
              key="modal-footer"
              className="flex justify-end items-center gap-2"
            >
              <button
                key="Login"
                className="bg-mainColor text-white px-4 py-2 rounded-md"
                onClick={() => navigate("/Login")}
              >
                {language === "ar" ? "تسجيل الدخول" : "Log in"}
              </button>
              <button
                key="cancel"
                className="bg-gray-300 text-black px-4 py-2 rounded-md"
                onClick={() => setIsModalVisible(false)}
              >
                {language === "ar" ? "إلغاء" : "Cancel"}
              </button>
            </div>,
          ]}
        >
          <p className="text-center">
            {language === "ar"
              ? "أنت غير مسجل. يرجى إنشاء حساب أولاً."
              : "You are not registered. Please create an account first."}
          </p>
        </Modal>
      </div>
    </div>
  );
}

export default ProductsBrand;
